import { Banner, Button, useLocale } from '@nolens/ui';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { PLAN_LIMIT_EVENT } from '../lib/api';
import { componentsText } from '../i18n/components';
import { publicPaths } from '../i18n/landing';

/**
 * Aviso único quando a API recusa algo por causa do plano (402 PLAN_LIMIT): diz o quê e
 * leva aos planos. Vale para qualquer ação (guias, partilha, marca, IA, convites…).
 */
export function PlanLimitNotice() {
  const t = componentsText(useLocale());
  const pricingPath = publicPaths(useLocale()).pricing;
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    const on = (e: Event) => setMsg((e as CustomEvent<string>).detail);
    window.addEventListener(PLAN_LIMIT_EVENT, on);
    return () => window.removeEventListener(PLAN_LIMIT_EVENT, on);
  }, []);
  if (!msg) return null;
  return (
    <div
      className="no-print fixed inset-x-0 bottom-4 z-30 mx-auto w-[min(560px,calc(100%-32px))]"
      role="alert"
      data-plan-limit
    >
      <Banner tone="attention">
        <div className="flex flex-wrap items-center gap-3">
          <span className="min-w-0 flex-1">{msg}</span>
          <Link to={pricingPath} onClick={() => setMsg(null)}>
            <Button size="sm">{t.seePlans}</Button>
          </Link>
          <Button size="sm" variant="ghost" onClick={() => setMsg(null)}>
            {t.close}
          </Button>
        </div>
      </Banner>
    </div>
  );
}

/** Etiqueta «Pro» ao lado de uma funcionalidade paga. */
export function ProTag() {
  return (
    <span className="ml-1.5 rounded-full bg-accent-soft px-1.5 py-0.5 text-[10.5px] font-semibold uppercase tracking-wide text-accent-text">
      Pro
    </span>
  );
}
